import * as React from 'react'
import type { CalendarEvent } from '../../typings'
import { EventTile } from './EventTile'
import { AllDayMore } from './AllDayMore'

type Props = {
  events: CalendarEvent[]
  day: Date
  /** Opens the day view; without it "+N more" is a plain note. */
  onShowDay?: (day: Date) => void
}

// Same cap as a month cell; also keeps the sticky header a bounded height.
const MAX_ROWS = 3

export function AllDayChips({ events, day, onShowDay }: Props) {
  const overflowing = events.length > MAX_ROWS
  const shown = overflowing ? events.slice(0, MAX_ROWS - 1) : events
  const hiddenCount = events.length - shown.length

  return (
    <>
      {shown.map((event) => (
        <EventTile key={event.id} event={event} variant="allDayWeek" />
      ))}
      {hiddenCount > 0 && (
        <AllDayMore count={hiddenCount} day={day} onShowDay={onShowDay} />
      )}
    </>
  )
}
